import _ from "lodash";
import { Update } from "@mui/icons-material";
import { MenuItem, Typography } from "@mui/material";
import React from "react";
import { TimeTableActionMenuProps } from "../../TimeTable.tsx";
import { v7 } from "uuid";

export const TwentyFourHourAction = <T,>({
  onChange,
  openingHours,
  row,
  handleClose,
  defaultData,
}: Pick<TimeTableActionMenuProps<T>, "onChange" | "openingHours" | "row" | "defaultData"> & {
  handleClose: () => void;
}) => {
  return (
    <MenuItem
      onClick={() => {
        const newOpeningHours = _.cloneDeep(openingHours);
        newOpeningHours[row.dayOrDate] = [{ id: v7(), hours: "00:00-24:00", data: defaultData }];
        onChange(newOpeningHours);
        handleClose();
      }}
    >
      <Update />
      <Typography>24H Open</Typography>
    </MenuItem>
  );
};
